import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Loader2, Users } from "lucide-react";
import { api } from "../lib/api";

const ProjectDetail = () => {
  const { slug } = useParams();
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try { setProject(await api.getProject(slug)); }
      catch (err) { if (err?.response?.status === 404) setNotFound(true); }
      finally { setLoading(false); }
    })();
  }, [slug]);

  if (loading) {
    return (
      <div className="mx-auto max-w-3xl px-4 py-20 text-center text-zinc-400">
        <Loader2 className="mx-auto h-6 w-6 animate-spin" />
      </div>
    );
  }
  if (notFound || !project) {
    return (
      <div className="mx-auto max-w-3xl px-4 py-20 text-center">
        <h1 className="text-2xl font-bold text-white">Projekt nicht gefunden</h1>
        <Link to="/projekte" className="mt-4 inline-block text-[#b39bff]">Zur Übersicht</Link>
      </div>
    );
  }

  return (
    <section className="mx-auto max-w-6xl px-4 py-10">
      <Link to="/projekte" className="inline-flex items-center gap-1 text-sm text-zinc-400 hover:text-white">
        <ArrowLeft className="h-4 w-4" /> Alle Projekte
      </Link>

      <div className="mt-6 flex items-start gap-4">
        <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-lg bg-gradient-to-br from-[#7c4dff]/30 to-[#ff9800]/20 border border-white/10">
          <Users className="h-6 w-6 text-[#b39bff]" />
        </div>
        <div>
          <div className="text-[10px] font-semibold uppercase tracking-[0.22em] text-[#9d7bff]">Projekt</div>
          <h1 className="mt-1 text-3xl font-bold text-white">{project.title}</h1>
          <p className="mt-2 text-sm text-zinc-400 max-w-2xl">{project.description}</p>
        </div>
      </div>

      <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5">
        {(project.members || []).map((m) => (
          <Link
            key={m.id}
            to={`/u/${encodeURIComponent(m.habbo_name)}`}
            data-testid={`project-member-link-${m.habbo_name}`}
            className="card-hover relative overflow-hidden rounded-xl border border-white/10 bg-[#0f141b] p-4 text-center group block transition-colors hover:border-[#7c4dff]/50"
          >
            {m.background_image_url && (
              <>
                <div aria-hidden className="absolute inset-0" style={{ backgroundImage: `url(${m.background_image_url})`, backgroundSize: "cover", backgroundPosition: "center" }} />
                <div aria-hidden className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(15,20,27,0.45) 0%, rgba(15,20,27,0.92) 80%)" }} />
              </>
            )}
            <div className="relative">
              {m.hotel_flag && m.hotel !== "de" && (
                <div className="absolute right-0 top-0 text-base" title={m.hotel_label}>{m.hotel_flag}</div>
              )}
              <div className="mx-auto flex h-28 w-28 items-center justify-center overflow-hidden">
                <img src={m.avatar} alt={m.habbo_name} className="hb-pixel-img group-hover:scale-105 transition-transform" loading="lazy" />
              </div>
              <div className="mt-2 text-sm font-semibold text-white truncate group-hover:text-[#b39bff] drop-shadow" title={m.habbo_name}>{m.habbo_name}</div>
              <div className="text-xs text-[#9d7bff]">{m.role}</div>
            </div>
          </Link>
        ))}
        {(!project.members || project.members.length === 0) && (
          <div className="col-span-full text-center text-sm text-zinc-500 py-10">Noch keine Mitglieder eingetragen.</div>
        )}
      </div>
    </section>
  );
};

export default ProjectDetail;
